import { useState } from "react";

export const useModalStates = () => {
  const [sendToPlanModalType, setSendToPlanModalType] = useState<
    "send_to_plan" | "retry_qa" | "fetch_qa"
  >("send_to_plan");
  const [openRerunModal, setOpenRerunModal] = useState(false);
  const [rerunType, setRerunType] = useState<"onco-emr" | "cmm" | "">("");
  const [rerunOrderData, setRerunOrderData] = useState<any>(null);
  const [selectedOrderIdForRerun, setSelectedOrderIdForRerun] = useState<
    string | null
  >(null);
  const [openReportPrescriptionModal, setOpenReportPrescriptionModal] =
    useState(false);
  const [
    selectedOrderIdForReportPrescription,
    setSelectedOrderIdForReportPrescription,
  ] = useState<string | null>(null);
  const [openReportMedicationModal, setOpenReportMedicationModal] =
    useState(false);
  const [
    selectedOrderIdForReportMedication,
    setSelectedOrderIdForReportMedication,
  ] = useState<string | null>(null);

  const closeRerunModal = () => {
    setOpenRerunModal(false);
    setSelectedOrderIdForRerun(null);
    setRerunType("");
    setRerunOrderData(null);
  };

  const closeReportPrescriptionModal = () => {
    setOpenReportPrescriptionModal(false);
    setSelectedOrderIdForReportPrescription(null);
  };

  const closeReportMedicationModal = () => {
    setOpenReportMedicationModal(false);
    setSelectedOrderIdForReportMedication(null);
  };

  return {
    sendToPlanModalType,
    setSendToPlanModalType,
    openRerunModal,
    setOpenRerunModal,
    rerunType,
    setRerunType,
    rerunOrderData,
    setRerunOrderData,
    selectedOrderIdForRerun,
    setSelectedOrderIdForRerun,
    openReportPrescriptionModal,
    setOpenReportPrescriptionModal,
    selectedOrderIdForReportPrescription,
    setSelectedOrderIdForReportPrescription,
    openReportMedicationModal,
    setOpenReportMedicationModal,
    selectedOrderIdForReportMedication,
    setSelectedOrderIdForReportMedication,
    closeRerunModal,
    closeReportPrescriptionModal,
    closeReportMedicationModal,
  };
};
